import { STYLE_KEYS, STYLES, styleSummary } from "@/lib/disc";

export function StyleMeter({ style, max = 10, showLabel = true, className = "", testId }) {
  const vec = style || {};
  const summary = styleSummary(vec);
  return (
    <div className={className} data-testid={testId}>
      <div className="flex items-end gap-1.5 h-8">
        {STYLE_KEYS.map((k) => {
          const v = Math.max(0, Math.min(max, Number(vec[k]) || 0));
          const pct = Math.max(8, (v / max) * 100);
          return (
            <div key={k} className="flex flex-col items-center gap-1 flex-1" title={`${STYLES[k].name}: ${v}/${max}`}>
              <div className="w-full h-5 flex items-end rounded-sm bg-slate-800/70 overflow-hidden">
                <div className="w-full rounded-sm transition-all" style={{ height: `${pct}%`, background: STYLES[k].color }} />
              </div>
              <span className="text-[9px] font-mono-tech font-bold leading-none" style={{ color: STYLES[k].color }}>{k}</span>
            </div>
          );
        })}
      </div>
      {showLabel && summary && (
        <div className="text-[11px] text-slate-400 mt-1.5 truncate">
          <span className="font-semibold text-slate-200">{summary.primary.name}</span> · {summary.secondary.name}
        </div>
      )}
    </div>
  );
}
